import { api } from "./api";

// ---- Config ----
export const psGetConfig = async () => (await api.get("/ps/config")).data;

// ---- Order (panier DRAFT) ----
export const psCreateOrder = async () => (await api.post("/ps/orders", {})).data;
export const psGetOrder = async (id) => (await api.get(`/ps/orders/${id}`)).data;
export const psDeleteOrder = async (id) => (await api.delete(`/ps/orders/${id}`)).data;

// ---- Services (SubOrders) ----
export const psAddService = async (id, stop_type) =>
  (await api.post(`/ps/orders/${id}/suborders`, { stop_type })).data;
export const psRemoveService = async (id, stop) =>
  (await api.delete(`/ps/orders/${id}/suborders/${stop}`)).data;

// ---- Articles ----
export const psAddItem = async (id, stop, body) =>
  (await api.post(`/ps/orders/${id}/suborders/${stop}/items`, body)).data;
export const psDeleteItem = async (id, stop, itemId) =>
  (await api.delete(`/ps/orders/${id}/suborders/${stop}/items/${itemId}`)).data;

// ---- Livraison ----
export const psDeliveryOptions = async (orderId) =>
  (await api.get("/ps/delivery-options", { params: orderId ? { order_id: orderId } : {} })).data;
export const psSetDelivery = async (orderId, body) =>
  (await api.post(`/ps/orders/${orderId}/delivery`, body)).data;

// ---- Tarification ----
export const psGetQuote = async (orderId) => (await api.get(`/ps/orders/${orderId}/quote`)).data;
export const psSetPricingAddress = async (orderId, body) =>
  (await api.post(`/ps/orders/${orderId}/pricing-address`, body)).data;

// ---- Checkout + préautorisation ----
export const psGetCheckout = async (orderId) => (await api.get(`/ps/orders/${orderId}/checkout`)).data;
export const psAcceptQuote = async (orderId) =>
  (await api.post(`/ps/orders/${orderId}/checkout/accept-quote`, {})).data;
export const psAuthorize = async (orderId, idempotency_key, accepted_quote_version) =>
  (await api.post(`/ps/orders/${orderId}/payment/authorize`, { idempotency_key, accepted_quote_version })).data;

// ---- Mandat pharmacie ----
export const psSetPharmacyMandate = async (orderId, body) =>
  (await api.post(`/ps/orders/${orderId}/suborders/PHARMACY/mandate`, body)).data;

// ---- Suivi temps réel ----
export const psGetTrack = async (token) => (await api.get(`/ps/track/${token}`)).data;
export const psGetSubstitutionSummary = async (orderId) =>
  (await api.get("/ps/substitutions/summary", { params: { order_id: orderId } })).data;

// ---- Historique client (autorisé par track_token) ----
export const psGetOrderRecap = async (token) =>
  (await api.get(`/ps/orders/track/${token}/recap`)).data;
